import { classnames } from '@/helpers';
import { ReactNode } from 'react';

export const DealPriceLine = ({ price, originalPrice }: { price: string; originalPrice?: string }) => {
  const hasDiscountedPrice = Boolean(originalPrice) && originalPrice !== price;
  return (
    <div className="gap-x-xs flex flex-wrap items-center">
      <span
        className={classnames(
          'text-l text-nowrap font-bold',
          hasDiscountedPrice ? 'text-fg_highlight' : 'text-fg_primary',
        )}>
        {price}
      </span>
      {hasDiscountedPrice && <span className="text-fg_secondary text-l text-nowrap line-through">{originalPrice}</span>}
    </div>
  );
};

export const MPServiceCardFooter = ({
  upper,
  lower,
  right,
}: {
  upper: ReactNode;
  lower: ReactNode;
  right: ReactNode;
}) => {
  return (
    <div className="pt-md border-border_regular gap-x-sm gap-y-2xs grid grid-cols-[1fr_auto] border-t">
      <div className="col-start-1 row-start-1">{upper}</div>
      {lower && <div className="gap-x-xs col-start-1 row-start-2 flex items-center">{lower}</div>}
      {right && <div className="col-start-2 row-span-2 row-start-1 self-center">{right}</div>}
    </div>
  );
};
